import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { withRouter } from 'react-router-dom';

import PortalCosignerDataPage from './PortalCosignerDataPage';
import { newAlert } from '../../../actions/alert_actions';
import { setCurrentStep, autoSkipStep } from '../../../actions/stepper_actions';
import {
  checkThirdStep,
  setNextStep,
  resetCosignerData,
  checkGeneralWarrantySaleScore,
  getAvailableQuotaNoHolder,
  changeQuotas
} from '../../../actions/portal_financing_actions';

function mapStateToProps(state) {
  const pf = state.portalFinancing;

  return {
    process: state.stepper.process,
    promissory: pf.promissory,
    loading: pf.stepIsLoading,
    nextStep: state.stepper.nextStep,
    portalNext: state.stepper.portalNext,
    promissoryNext: state.stepper.promissoryNext,
    serverErrors: pf.errors,
    requiresCosigner: pf.require_cosigner,
    holder: pf.holder,
    supplier: state.authentication.currentUser.supplier,
    routes: state.stepper.routes,
    solidaryDebtorCauses: state.globalSetting.orgData.solidary_debtor_causes,
    secureSaleActive: state.globalSetting.orgData.secure_sale_active,
    generalWarrantySaleActive: state.globalSetting.orgData.general_warranty_sale_active || {},
    debtorMaxAge: state.globalSetting.orgData.debtor_max_age,
    isSecureSaleWithExperianActive: state.globalSetting.orgData.is_secure_sale_with_experian_active,
    isGeneralWarrantyWithScoreActive: state.globalSetting.orgData.is_general_warranty_with_score_active,
    categories: state.globalSetting.orgData.categories,
    generalWarrantyCategoriesConfig: state.globalSetting.orgData.general_warranty_case_three_categories_config,
    canCheckSecureSaleScoreExperian: state.authentication.currentUser.canCheckSecureSaleScoreExperian,
    canCheckGeneralWarrantyScore: state.authentication.currentUser.canCheckGeneralWarrantyScore,
    canSellSecureSaleByZone: pf.can_sell_secure_sale_by_zone,
    isCommercialSale: pf.is_commercial_sale,
    debtor: {
      debtor_contract_number: pf.debtor_contract_number,
      debtor_identification_type: pf.debtor_identification_type,
      debtor_identification: pf.debtor_identification,
      debtor_birthdate: pf.debtor_birthdate,
      debtor_expedition_date: pf.ani_debtor_response ? (pf.ani_debtor_response.data.expedition_date || debtor.id_expedition_date) : pf.experian_debtor_response ? pf.experian_debtor_response.documento.fecha_expedicion : '',
    },
    cosigner: {
      contract: pf.cosigner_contract_number,
      identificationType: pf.cosigner_identification_type,
      identification: pf.cosigner_identification,
      birthdate: pf.cosigner_birthdate,
      causal: pf.reason_solidary_debtor
    },
    transfer: {
      requestMade: pf.moveQuotaData.requestMade,
      contract: pf.moveQuotaData.contract,
      identificationType: pf.moveQuotaData.identificationType,
      identification: pf.moveQuotaData.identification,
      birthdate: pf.moveQuotaData.birthdate
    },
    specialSale: pf.special_sale,
    gnpGasApplianceSaleEvaluation: pf.gnp_gas_appliance_evaluation,
    pointOfSales: state.authentication.currentUser.pointOfSales,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    newAlert: bindActionCreators(newAlert, dispatch),
    setCurrentStep: bindActionCreators(setCurrentStep, dispatch),
    checkThirdStep: bindActionCreators(checkThirdStep, dispatch),
    setNextStep: bindActionCreators(setNextStep, dispatch),
    resetCosignerData: bindActionCreators(resetCosignerData, dispatch),
    checkGeneralWarrantySaleScore: bindActionCreators(checkGeneralWarrantySaleScore, dispatch),
    getAvailableQuotaNoHolder: bindActionCreators(getAvailableQuotaNoHolder, dispatch),
    changeQuotas: bindActionCreators(changeQuotas, dispatch),
    autoSkipStep: bindActionCreators(autoSkipStep, dispatch)
  };
}

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(PortalCosignerDataPage);
